import {AxiosError, AxiosResponse} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';

type Params = {
  identifier: string;
  recaptcha: string;
};

export function useForgetPasswordMutation(options?: UseMutationOptions<void, AxiosError, Params>) {
  return useMutation<void, AxiosError, Params>(
    (params) => api.post<Params, AxiosResponse<void>>('v2/forget-password', params).then((res) => res.data),
    {
      ...options,
      onSuccess: (...params) => {
        options?.onSuccess?.(...params);
      },
    },
  );
}
